import { create } from 'zustand';

type PanelContentType = 'gang-details' | 'lifecycle' | 'help' | null;

interface GangsPanelState {
  isOpen: boolean;
  contentType: PanelContentType;
  gangId: string | null;
  openGangDetails: (gangId: string) => void;
  openLifecyclePanel: () => void;
  transitionToEdit: (gangId: string) => void;
  openHelp: () => void;
  closePanel: () => void;
}

export const useGangsPanelStore = create<GangsPanelState>(set => ({
  isOpen: false,
  contentType: null,
  gangId: null,

  openGangDetails: (gangId: string) => {
    set({
      isOpen: true,
      contentType: 'gang-details',
      gangId,
    });
  },

  openLifecyclePanel: () => {
    set({
      isOpen: true,
      contentType: 'lifecycle',
      gangId: null,
    });
  },

  transitionToEdit: (gangId: string) => {
    set({
      isOpen: true,
      contentType: 'lifecycle',
      gangId,
    });
  },

  openHelp: () => {
    set({
      isOpen: true,
      contentType: 'help',
      gangId: null,
    });
  },

  closePanel: () => {
    set({
      isOpen: false,
      contentType: null,
      gangId: null,
    });
  },
}));
